import { render, staticRenderFns } from "./bookContent.vue?vue&type=template&id=324422b9&scoped=true&"
import script from "./bookContent.vue?vue&type=script&lang=js&"
export * from "./bookContent.vue?vue&type=script&lang=js&"
import style0 from "./bookContent.vue?vue&type=style&index=0&id=324422b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324422b9",
  null
  
)

export default component.exports